var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#b90a0a",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    "data-originalfillcolor": "#000000",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328,374.8c-8.2-16.9-18.8-29.2-37.1-21.7l-36.1,13.4c-28.9,13.4-43.3,0-57.8-20.2l-65-147.8c-8.1-16.9-3.9-32.8,14.4-40.3 l50.5-20.2c18.3-7.6,15.4-23.4,7.2-40.3L161,17.1c-8.2-16.9-25-21-43.3-13.5C81,18.7,50.7,42.4,31.1,77.5 c-24,42.9-12,102.6-7.2,127.7c4.8,25.1,21.6,69.1,43.3,114.2c21.7,45.2,40.8,80.7,57.8,100.8c17,20.1,57.8,75.1,108.3,87.4 c41.4,10,86.1,1.6,122.7-13.5c18.3-7.5,18.4-23.4,10.2-40.4L328,374.8z M489.4,137.7L450,98.3l-59.1,59.1l-59.1-59.1l-39.4,39.4 l59.1,59.1L292.4,256l39.4,39.4l59.1-59.1l59.1,59.1l39.4-39.4l-59.1-59.1L489.4,137.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissCall);
export default __webpack_public_path__ + "static/media/miss_call.129162dc8238499f014aa59df51b81b9.svg";
export { ForwardRef as ReactComponent };